import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { WmsPickingListGendocLinkContainer } from "../../../../../models/aggregates/warehouse/index";
import { ApiResponseModel } from "../shared";
import { ApiVisa } from "../shared";
import { Observable } from 'rxjs';

@Injectable({ providedIn: "root" })
export class WmsPickingListGendocLinkService extends BaseApiTemplateService<WmsPickingListGendocLinkContainer> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-list-gendoc-links/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-list-gendoc-links/backoffice-ep";
    this.httpClient = http;
  }

  public createMulti(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-list-gendoc-links/multi/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }
  
  public updateMulti(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-list-gendoc-links/multi/backoffice-ep";
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      payload,
      this.getHttpHeader(visa)
    );
  }

  public deleteMulti(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-list-gendoc-links/multi-delete/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public createPickingLinesAndSequence(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/picking-list-gendoc-links/create-picking-line-sequence/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
